import * as DialogPrimitive from '@radix-ui/react-dialog';

export const PvDialog = DialogPrimitive.Root;
